module.exports = __webpack_public_path__ + "static/media/T14-T25-01.7df7f163.svg";